const cmaOps = require('./cmaOperations');

let newArr = null;

module.exports = function (fys, arrayLength, cma_pl_values, cma_bs_values, cma_kfp_values) {
  cma_kfp_values.cma_kfp_1 = cmaOps.sum(cma_pl_values.cma_pl_5, cma_pl_values.cma_pl_7);
  cma_kfp_values.cma_kfp_2 = cmaOps.sum(cma_pl_values.cma_pl_22, cma_pl_values.cma_pl_23, cma_pl_values.cma_pl_45);
  cma_kfp_values.cma_kfp_3 = cmaOps.percentage(cma_kfp_values.cma_kfp_2, cma_kfp_values.cma_kfp_1);
  cma_kfp_values.cma_kfp_4 = cma_pl_values.cma_pl_46;
  cma_kfp_values.cma_kfp_5 = cmaOps.sum(cma_pl_values.cma_pl_22, cma_pl_values.cma_pl_23);
  cma_kfp_values.cma_kfp_6 = cmaOps.difference(cma_kfp_values.cma_kfp_2, cma_kfp_values.cma_kfp_4, cma_kfp_values.cma_kfp_5);
  cma_kfp_values.cma_kfp_7 = cma_pl_values.cma_pl_79;
  cma_kfp_values.cma_kfp_8 = cma_pl_values.cma_pl_80;
  cma_kfp_values.cma_kfp_9 = cma_pl_values.cma_pl_85;
  cma_kfp_values.cma_kfp_10 = cmaOps.percentage(cma_kfp_values.cma_kfp_9, cma_kfp_values.cma_kfp_1);
  cma_kfp_values.cma_kfp_11 = cmaOps.difference(cmaOps.sum(cma_kfp_values.cma_kfp_9, cma_kfp_values.cma_kfp_5, cma_pl_values.cma_pl_72, cma_pl_values.cma_pl_83), cma_pl_values.cma_pl_59, cma_pl_values.cma_pl_86);
  cma_kfp_values.cma_kfp_12 = cma_bs_values.cma_bs_95;
  cma_kfp_values.cma_kfp_13 = cma_bs_values.cma_bs_118;
  cma_kfp_values.cma_kfp_14 = cma_bs_values.cma_bs_53;
  cma_kfp_values.cma_kfp_16 = cma_bs_values.cma_bs_98;
  cma_kfp_values.cma_kfp_17 = cma_bs_values.cma_bs_99;
  cma_kfp_values.cma_kfp_18 = cmaOps.difference(cmaOps.sum(cma_kfp_values.cma_kfp_13, cma_kfp_values.cma_kfp_14), cma_kfp_values.cma_kfp_16, cma_kfp_values.cma_kfp_17);
  cma_kfp_values.cma_kfp_19 = cmaOps.difference(cma_bs_values.cma_bs_38, cma_bs_values.cma_bs_37);
  cma_kfp_values.cma_kfp_21 = cma_bs_values.cma_bs_13;
  cma_kfp_values.cma_kfp_22 = cmaOps.sum(cma_bs_values.cma_bs_6, cma_bs_values.cma_bs_7);
  cma_kfp_values.cma_kfp_20 = cmaOps.sum(cma_kfp_values.cma_kfp_21, cma_kfp_values.cma_kfp_22);
  cma_kfp_values.cma_kfp_23 = cma_bs_values.cma_bs_2;
  cma_kfp_values.cma_kfp_24 = cmaOps.sum(cma_kfp_values.cma_kfp_19, cma_kfp_values.cma_kfp_20, cma_kfp_values.cma_kfp_23);
  cma_kfp_values.cma_kfp_26 = cmaOps.sum(cma_kfp_values.cma_kfp_24, cma_kfp_values.cma_kfp_25);
  cma_kfp_values.cma_kfp_27 = cmaOps.divide(cma_kfp_values.cma_kfp_19, cma_kfp_values.cma_kfp_13);
  cma_kfp_values.cma_kfp_28 = cmaOps.divide(cma_kfp_values.cma_kfp_19, cma_kfp_values.cma_kfp_18);
  cma_kfp_values.cma_kfp_29 = cmaOps.divide(cma_kfp_values.cma_kfp_26, cma_kfp_values.cma_kfp_13);
  cma_kfp_values.cma_kfp_30 = cmaOps.divide(cma_kfp_values.cma_kfp_26, cma_kfp_values.cma_kfp_18);
  cma_kfp_values.cma_kfp_31 = cma_bs_values.cma_bs_37;
  cma_kfp_values.cma_kfp_32 = cmaOps.sum(cma_bs_values.cma_bs_39, cma_kfp_values.cma_kfp_25);
  cma_kfp_values.cma_kfp_33 = cmaOps.divide(cma_kfp_values.cma_kfp_32, cma_kfp_values.cma_kfp_13);
  cma_kfp_values.cma_kfp_34 = cmaOps.divide(cma_kfp_values.cma_kfp_32, cma_kfp_values.cma_kfp_18);
  cma_kfp_values.cma_kfp_35 = cma_bs_values.cma_bs_89;
  cma_kfp_values.cma_kfp_36 = cma_bs_values.cma_bs_28;
  cma_kfp_values.cma_kfp_37 = cmaOps.difference(cma_kfp_values.cma_kfp_35, cma_kfp_values.cma_kfp_36);
  cma_kfp_values.cma_kfp_38 = cmaOps.divide(cma_kfp_values.cma_kfp_35, cma_kfp_values.cma_kfp_36);
  cma_kfp_values.cma_kfp_39 = cma_bs_values.cma_bs_112;

  // cma_kfp_values.cma_kfp_40
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = ((cma_kfp_values.cma_kfp_1[i] * 12)/fys[i].months)/cma_kfp_values.cma_kfp_12[i];
  }
  cma_kfp_values.cma_kfp_40 = newArr;

  // cma_kfp_values.cma_kfp_41
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = ((((cma_kfp_values.cma_kfp_4[i] + cma_kfp_values.cma_kfp_6[i] + cma_pl_values.cma_pl_35[i]) * 12) / fys[i].months) / (cmaOps.getPositiveValueOnly(cma_kfp_values.cma_kfp_13[i]) + cmaOps.getPositiveValueOnly(cma_kfp_values.cma_kfp_14[i]) + cma_kfp_values.cma_kfp_24[i])) * 100;
  }
  cma_kfp_values.cma_kfp_41 = newArr;

  cma_kfp_values.cma_kfp_42 = cmaOps.divide(cmaOps.difference(cmaOps.sum(cma_kfp_values.cma_kfp_4, cma_kfp_values.cma_kfp_5, cma_kfp_values.cma_kfp_9, cma_pl_values.cma_pl_35, cma_pl_values.cma_pl_83), cma_kfp_values.cma_kfp_7), cmaOps.sum(cma_kfp_values.cma_kfp_4, cma_pl_values.cma_pl_35));

  // cma_kfp_values.cma_kfp_43
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = cmaOps.getValue(cma_kfp_values.cma_kfp_26[i]/((cma_kfp_values.cma_kfp_2[i] * 12)/fys[i].months));
  }
  cma_kfp_values.cma_kfp_43 = newArr;

  // cma_kfp_values.cma_kfp_44
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = cmaOps.getValue(cma_kfp_values.cma_kfp_26[i]/((cma_kfp_values.cma_kfp_11[i] * 12)/fys[i].months));
  }
  cma_kfp_values.cma_kfp_44 = newArr;

  // cma_kfp_values.cma_kfp_45
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = cmaOps.getValue((365/((cma_pl_values.cma_pl_90[i] * 12)/fys[i].months)) * cma_bs_values.cma_bs_70[i]);
  }
  cma_kfp_values.cma_kfp_45 = newArr;

  // cma_kfp_values.cma_kfp_46
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = cmaOps.getValue(((cma_bs_values.cma_bs_66[i] + cma_bs_values.cma_bs_67[i] + cma_bs_values.cma_bs_107[i])/((cma_pl_values.cma_pl_5[i] * 12)/fys[i].months)) * 365);
  }
  cma_kfp_values.cma_kfp_46 = newArr;

  // cma_kfp_values.cma_kfp_47
  newArr = new Array(arrayLength);
  for (let i=0; i<arrayLength; i++) {
    newArr[i] = cmaOps.getValue((cma_bs_values.cma_bs_8[i]/((cma_pl_values.cma_pl_10[i] * 12)/fys[i].months)) * 365);
  }
  cma_kfp_values.cma_kfp_47 = newArr;

  cma_kfp_values.cma_kfp_48 = cmaOps.difference(cmaOps.sum(cma_kfp_values.cma_kfp_4, cma_kfp_values.cma_kfp_5, cma_kfp_values.cma_kfp_9, cma_bs_values.cma_bs_35, cma_bs_values.cma_bs_80), cma_kfp_values.cma_kfp_7);

  // cma_kfp_values.cma_kfp_49
  newArr = new Array(arrayLength);
  newArr[0] = 0;
  for (let i=1; i<arrayLength; i++) {
    newArr[i] = cma_pl_values.cma_pl_35[i] + cma_kfp_values.cma_kfp_4[i] + cma_kfp_values.cma_kfp_21[i-1];
  }
  cma_kfp_values.cma_kfp_49 = newArr;

  cma_kfp_values.cma_kfp_50 = cmaOps.divide(cma_kfp_values.cma_kfp_48, cma_kfp_values.cma_kfp_49);

  return cma_kfp_values;
};



// WEBPACK FOOTER //
// ./src/cma/calculations_KFP.js